<template>
    <q-carousel class="carousel-list">
        <q-carousel-control
            class="carousel-control"
            slot="control-nav" slot-scope="carousel"
            position="bottom-right"
            :offset="[30, -20]">
            <q-btn
                @click="carousel.previous"
                :disable="!carousel.canGoToPrevious"
                color="white" text-color="indigo-7"
                icon="arrow_back"
                round dense
                class="q-mr-small"
            />
            <q-btn
                @click="carousel.next"
                :disable="!carousel.canGoToNext"
                color="white" text-color="indigo-7"
                icon="arrow_forward"
                round dense
            />
        </q-carousel-control>

        <q-carousel-slide v-for="(chunk, i) in chunks" :key="i" style="height: 50vh">
            <div class="card-list">
                <v-card v-for="(item, j) in chunk" :key="j" :layout="layout" :item="transform(item)"
                        :is-video="isVideo" :internal-page="item.url ? false : true"  />
            </div>
        </q-carousel-slide>
    </q-carousel>
</template>

<script>
    import {
        QCarousel,
        QCarouselSlide,
        QCarouselControl,
        QBtn,
    } from 'quasar-framework'

    export default {
        name: 'VCarousel',
        props: {
            items: {
                type: Array,
                required: true,
            },
            layout: {
                type: String,
                required: true,
            },
            isVideo: Boolean,
        },
        components: {
            QBtn,
            QCarouselControl,
            QCarousel,
            QCarouselSlide,
        },
        computed: {
            chunks() {
                var chunks = []
                var chunk = 1
                if (this.layout == 'big')
                    chunk = this.$breakpoints.isGreaterThan('xs') ? 3 : 1
                if (this.layout == 'small')
                    chunk = this.$breakpoints.isGreaterThan('xs') ? 4 : 6
                for (var i = 0; i < this.items.length; i += chunk)
                    chunks.push(this.items.slice(i, i + chunk))
                return chunks
            },
        },
        data() {
            return {
                imageDefault: `${config.appUrlPortal}/img/p4f-icon.png`,
            }
        },
        methods: {
            transform(item) {
                return {
                    id: item.id,
                    title: item.title,
                    uri: item.url ? item.url : `content/${item.slug}`,
                    img: { url: item.img ? item.img : this.imageDefault },
                    desc: ``,
                    slug: item.slug,
                    subtitle: item.subtitle,
                    published_date: '',
                }
            },
            handleClick(item) {
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .carousel-control
        margin 0 10px 0 0 !important
        @media (max-width 768px)
            bottom 10px
            width 100%
            display flex
            justify-content flex-end
            padding-left 18px
        @media (max-width 768px) and (orientation: landscape)
            display none

    .carousel-list
        margin-top -50px
        height 370px
        @media (max-height 768px)
            height calc(50vh - 30px) !important
            padding-bottom: 20px;
        .q-carousel-inner
            height: calc(54vh - 50px) !important

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/front/Carousel.vue